import TableOfContents from "./components/TableOfContents";
import RelatedTrainingsBlog from "./components/RelatedTrainingsBlog";

window.addEventListener("DOMContentLoaded", (event) => {
  const tocSection = document.querySelector(".blog-toc-section");
  const trainingSection = document.querySelector(".related-trainings-section");

  if (tocSection) {
    new TableOfContents(tocSection).init();
  }

  if (trainingSection) {
    new RelatedTrainingsBlog(trainingSection).init();
  }
});
